/* [CM] Aviso precio por ml — muestra el aviso cuando el tamaño chico está seleccionado. */
(function () {
  if (window.__cmPpmNotice) return;
  window.__cmPpmNotice = true;

  /* QA: ?ppm=1 activa la variante sin Intelligems (persiste en la sesión); ?ppm=0 la apaga. */
  try {
    var params = new URLSearchParams(window.location.search);
    if (params.has('ppm')) window.sessionStorage.setItem('ppm', params.get('ppm'));
    if (window.sessionStorage.getItem('ppm') === '1') {
      var style = document.createElement('style');
      style.id = 'ppm-qa';
      style.textContent = '.cm-ppm--test.is-active{display:flex!important}';
      document.head.appendChild(style);
    }
  } catch (error) {
    /* noop */
  }

  function normalize(value) {
    return String(value || '').toLowerCase().replace(/\s+/g, '');
  }

  function update(picker) {
    var notice = picker.querySelector('[data-cm-ppm]');
    if (!notice) return;
    var small = notice.getAttribute('data-small');
    var controls = picker.querySelectorAll('input[type="radio"]:checked, select');
    var active = Array.prototype.some.call(controls, function (el) {
      return normalize(el.value) === small;
    });
    notice.classList.toggle('is-active', active);
  }

  function pickers() {
    return document.querySelectorAll('variant-selects, variant-radios');
  }

  function bind(picker) {
    if (picker.__cmPpmBound) return;
    picker.__cmPpmBound = true;
    picker.addEventListener('change', function () { update(picker); });
    update(picker);
  }

  function init() {
    pickers().forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Cambios de variante hechos desde otros pickers (sticky ATC) publican variant-change. */
  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      pickers().forEach(function (picker) { bind(picker); update(picker); });
    });
  }

  /* Pickers renderizados después (quick add, secciones dinámicas). */
  new MutationObserver(function () {
    pickers().forEach(bind);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
